import Header from '../Header/Header.js'
import Accordion from './Accodion.js';
import Footer from '../Footer/Footer.js';
import { HiOutlineShoppingCart, HiOutlineOfficeBuilding, HiOutlineUser, HiOutlineArchive } from "react-icons/hi";
import {
    HiOutlineLocationMarker,
    HiOutlineChip,
} from "react-icons/hi";
import { MdOutlineShareLocation } from "react-icons/md";
import Mainone from './Mainone.js';
import Typefive from './Typefive.js';
import Typefour from './Typefour.js';
import Typesix from './Typesix.js';
import './Accodion.css'
import useScrollToTop from '../components/useScrollToTop.js';
import { LuBox } from "react-icons/lu";


const Home = () => {
    useScrollToTop();

    return (
        <div>
            <Header />

            <div className="relative isolate overflow-hidden bg-slate-900 pt-4 mb-0.5 sm:pt-9 2xl:h-[60vh]">
                <video
                    autoPlay
                    loop
                    muted
                    className="absolute inset-0 brightlight -z-10 h-full w-full object-cover object-right md:object-center"
                >
                    <source src="https://uklogistics.s3.ap-south-1.amazonaws.com/Video/Untitled_1080p_4.mp4" type="video/mp4" className='cursor-pointer' />
                    Your browser does not support the video tag.
                </video>

                <div className="mx-auto max-w-auto lg:px-8 h-full px-6 text-white cursor-pointers">
                    <p className='font-bold text-3xl text-gray-100'>AlgarXpress</p>
                    <p className='font-semibold text-xl mt-3 text-gray-200'>Domestic and Global Shipping Services</p>
                    <p className='text-end items-end mt-56 2xl:hidden mb-3'>www.algarxpress.com</p>
                </div>
            </div>
            <Mainone />
            <Typesix />


            {/* 
            <div className='flex flex-col lg:flex-row items-center md:px-6 lg:px-8 px-6 mt-2 mb-7 space-y-5 md:space-y-0 lg:space-x-10'>
                <div className='flex w-full lg:w-1/3'>
                    <img src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/AlgarHomepage.png" className='rounded-xl hover:opacity-75 cursor-pointer' alt="Ware" />
                </div>

                <div className="md:text-left w-full lg:w-2/3 md:pt-7 lg:pt-0">
                    <div className="grid grid-cols-1 md:grid-cols-2 2xl:md:grid-cols-1 gap-6">
                        <div className="p-6 border rounded-lg bg-slate-50">
                            <div className="flex flex-col items-center">
                                <div className="h-16 w-16 bg-slate-100 border rounded-full flex items-center justify-center text-black text-3xl">
                                    <HiOutlineShoppingCart />
                                </div>
                                <h3 className="mt-4 text-lg font-semibold text-gray-800">
                                    E-Commerce/Business Shipment
                                </h3>
                                <p className="mt-2 text-gray-600 text-sm text-center">
                                    Efficient and reliable Shipment services for e-commerce and business needs.
                                </p>
                            </div>
                        </div>
                        <div className="p-6 border rounded-lg bg-slate-50">
                            <div className="flex flex-col items-center">
                                <div className="h-16 w-16 bg-slate-100 border rounded-full flex items-center justify-center text-black text-3xl">
                                    <HiOutlineOfficeBuilding />
                                </div>
                                <h3 className="mt-4 text-lg font-semibold text-gray-800">
                                    Office Shipment
                                </h3>
                                <p className="mt-2 text-gray-600 text-sm text-center">
                                    Fast and secure Shipment solutions tailored for office requirements.
                                </p>
                            </div>
                        </div>
                        <div className="p-6 border rounded-lg bg-slate-50">
                            <div className="flex flex-col items-center">
                                <div className="h-16 w-16 bg-slate-100 border rounded-full flex items-center justify-center text-black text-3xl">
                                    <HiOutlineUser />
                                </div>
                                <h3 className="mt-4 text-lg font-semibold text-gray-800">
                                    Personal/Individual Shipment
                                </h3>
                                <p className="mt-2 text-gray-600 text-sm text-center">
                                    Personalized Shipment services for individuals with care and attention.
                                </p>
                            </div>
                        </div>
                        <div className="p-6 border rounded-lg bg-slate-50">
                            <div className="flex flex-col items-center">
                                <div className="h-16 w-16 bg-slate-100 border rounded-full flex items-center justify-center text-black text-3xl">
                                    <HiOutlineArchive />
                                </div>
                                <h3 className="mt-4 text-lg font-semibold text-gray-800">
                                    Other Shipment
                                </h3>
                                <p className="mt-2 text-gray-600 text-sm text-center">
                                    Flexible solutions for a variety of Shipment needs beyond standard categories.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex flex-col lg:flex-row items-center md:px-6 lg:px-8 px-6 mt-2 mb-20 space-y-5 md:space-y-0 lg:space-x-10'>
                <div className='flex w-full lg:w-1/3'>
                    <img src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/Algarxpresshomepage.png" className='rounded-xl hover:opacity-75 cursor-pointer' alt="Ware" />
                </div>

                <div className="md:text-left w-full lg:w-2/3 md:pt-7 lg:pt-0">
                    <div className="grid grid-cols-1 md:grid-cols-2 2xl:md:grid-cols-1 gap-6 ">
                        <div className="p-6 border rounded-lg bg-slate-50">
                            <div className="flex flex-col items-center">
                                <div className="h-16 w-16 bg-slate-100 border rounded-full flex items-center justify-center text-black text-3xl">
                                    <LuBox />
                                </div>
                                <h3 className="mt-4 text-lg font-semibold text-gray-800">
                                    Shipment Pickup from Home or Office
                                </h3>
                                <p className="mt-2 text-gray-600 text-sm text-center">
                                    Schedule a pickup from your home, office, or shop for hassle-free Shipment services.
                                </p>
                            </div>
                        </div>

                        <div className="p-6 border rounded-lg bg-slate-50">
                            <div className="flex flex-col items-center">
                                <div className="h-16 w-16 bg-slate-100 border rounded-full flex items-center justify-center text-black text-3xl">
                                    <MdOutlineShareLocation />
                                </div>
                                <h3 className="mt-4 text-lg font-semibold text-gray-800">
                                    Fast and Secure Delivery
                                </h3>
                                <p className="mt-2 text-gray-600 text-sm text-center">
                                    Deliver your Shipment quickly and securely to your desired location with ease.
                                </p>
                            </div>
                        </div>

                        <div className="p-6 border rounded-lg bg-slate-50">
                            <div className="flex flex-col items-center">
                                <div className="h-16 w-16 bg-slate-100 border rounded-full flex items-center justify-center text-black text-3xl">
                                    <HiOutlineLocationMarker />
                                </div>
                                <h3 className="mt-4 text-lg font-semibold text-gray-800">
                                    Real-Time Tracking
                                </h3>
                                <p className="mt-2 text-gray-600 text-sm text-center">
                                    Monitor your Shipment's status and location in real time for peace of mind.
                                </p>
                            </div>
                        </div>

                        <div className="p-6 border rounded-lg bg-slate-50">
                            <div className="flex flex-col items-center">
                                <div className="h-16 w-16 bg-slate-100 border rounded-full flex items-center justify-center text-black text-3xl">
                                    <HiOutlineChip />
                                </div>
                                <h3 className="mt-4 text-lg font-semibold text-gray-800">
                                    AI-Powered Operations
                                </h3>
                                <p className="mt-2 text-gray-600 text-sm text-center">
                                    Enhance efficiency and accuracy with AI-driven Shipment management solutions.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-8 px-4 md:px-8">
                <div>
                    <img
                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/algarXpreeswarehouse.png"
                        className="rounded-xl hover:opacity-75 cursor-pointer w-full"
                        alt="Warehouse Image 1"
                    />
                </div>

                <div className="space-y-8 content-center">
                    <img
                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/AlgarBikeimages.png"
                        className="rounded-xl hover:opacity-75 cursor-pointer w-full"
                        alt="Boxes Image 1"
                    />
                    <img
                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/algarwarehouse.png"
                        className="rounded-xl hover:opacity-75 cursor-pointer w-full"
                        alt="Home Bike Image 2"
                    />
                </div>

                <div>
                    <img
                        src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/algarboxpic.png"
                        className="rounded-xl md:hidden lg:block block hover:opacity-75 cursor-pointer w-full"
                        alt="Warehouse Image 3"
                    />
                </div>
            </div> */}

            <div className='md:pt-7 lg:pt-0 px-8 mt-9 md:mt-0 lg:mt-9  mb-6'>
                <p className='font-semibold text-lg mb-4'>Embracing Digital Technology for Seamless Logistics</p>
                <p>As part of our commitment to staying at the forefront of the logistics industry, we have embraced cutting-edge digital technologies that enable us to offer superior service and efficiency. The logistics sector is increasingly reliant on technology, and we have integrated digital tools across all facets of our operations to enhance the customer experience and streamline our internal processes.

                    One of our key innovations is the use of real-time tracking systems. From the moment your parcel is dispatched, you can follow its journey with our intuitive tracking interface, which provides up-to-the-minute updates on its location and status. This transparency allows you to plan accordingly and gives you peace of mind, knowing exactly when to expect your delivery.</p>
                <p className='text-slate-700 mt-8'>
                    ● We also leverage digital technologies to optimize our internal workflows. Our warehouse management systems use AI and machine learning to predict demand, manage inventory levels, and ensure the efficient allocation of resources. This not only reduces operational costs but also allows us to process and dispatch Shipment with unprecedented speed and accuracy.
                </p>
                <p className='text-slate-700 my-5'>
                    ● We also prioritize data security, ensuring that all customer information and shipment details are protected. Our systems are built with robust encryption and cybersecurity measures to safeguard your data from unauthorized access or breaches. You can trust that your parcel and personal information are safe in our hands.
                </p>
                {/* <p className='text-slate-700'>
                        ● AI-predictive demand for efficient distribution network. The company leverages artificial intelligence to predict demand patterns and anticipate shipping requirements. Our AI technology guides us toward the optimal locations for new distribution centers to fulfill our partner's logistics needs.
                    </p>  */}
                <p className='font-semibold text-lg mb-3'>The Future of Logistics: Growing and Innovating</p>
                <p className='text-slate-700'>
                    ● As we continue to grow, we remain committed to staying at the forefront of logistics innovation. Our goal is to not only meet but exceed the expectations of our customers by embracing new technologies, expanding our delivery network, and improving our services. We are constantly exploring ways to enhance the speed, security, and efficiency of our operations while maintaining our focus on providing exceptional customer support.
                </p>
                <p className='text-slate-700 my-5'>
                    ● In conclusion, our AlgarXpress company is built on a foundation of growth, innovation, and customer-first service. We prioritize the needs of our clients, ensuring that every parcel is delivered quickly, securely, and with the full support of our dedicated team. By leveraging digital technology, optimizing our processes, and maintaining a strong commitment to customer satisfaction, we provide a logistics experience that is second to none.
                </p>
                <p className='text-slate-700'>
                    ● Our commitment to customer satisfaction doesn’t end with delivery. We provide full support throughout the entire shipping process, from the moment you book a shipment to the point of delivery and beyond. Our customer service team is available to assist with any inquiries, provide updates, and resolve any issues that may arise. Whether you're facing a delayed shipment, need to modify delivery instructions, or have questions about our services, we're here to help.
                </p>
            </div>




            <Typefive />




            <Typefour />
            <Accordion />
            <div className='mt-14'>
                <Footer />
            </div>
        </div>
    )
}

export default Home
